// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ac1d45eded5ca67d5899","655":"7f504adf16c5ab6ff937"}[chunkId] + ".js";
};